module.exports = __webpack_public_path__ + "img/pay-scan.fcd96af6.png";